module.exports = __webpack_public_path__ + "static/media/deniz-istanbul.adbd5af9.jpg";